import { bindActionCreators } from 'redux';

import { showNotification } from 'components/Notification/actions';
import { confirmationChangeHandl, confirmationSend } from 'pages/Confirmation/actions';
import { workingChangeHandl } from 'pages/Working/actions';

export const FILE_CHANGE = 'FILE/FILE_CHANGE';
export const FILE_SEND = 'FILE/FILE_SEND';
export const FILE_TYPE_SELECT = 'FILE/FILE_TYPE_SELECT';
export const FILE_STEP = 'FILE/FILE_STEP';
export const FILE_LIST = 'FILE/FILE_LIST';
export const FILE_LIST_SAVE = 'FILE/FILE_LIST_SAVE';
export const FILE_PROGRESS = 'FILE/FILE_PROGRESS';
export const FILE_UPLOADING = 'FILE/FILE_UPLOADING';
export const FILE_UPLOADED = 'FILE/FILE_UPLOADED';
export const FILE_NOTIFICATON = 'FILE/FILE_NOTIFICATON';


const fileNotificationLater = cb => ({
  type: FILE_NOTIFICATON,
  payload: { cb }
});

const fileTypeChange = type => ({
  type: FILE_TYPE_SELECT,
  payload: { type }
});

const fileStepChange = () => ({
  type: FILE_STEP
});

const fileSend = (callback, file) => ({
  type: FILE_SEND,
  payload: { callback, file }
});

const fileList = callback => ({
  type: FILE_LIST,
  payload: { callback }
});

export const saveFileList = uploaded => ({
  type: FILE_LIST_SAVE,
  payload: { uploaded }
});

export const progressFile = progress => ({
  type: FILE_PROGRESS,
  payload: { progress }
});

export const fileUploading = () => ({
  type: FILE_UPLOADING
});

export const fileUploaded = (loading = true) => ({
  type: FILE_UPLOADED,
  payload: { loading }
});


function containerActions(dispatch) {
  return bindActionCreators(
    {
      showNotification,
      fileTypeChange,
      fileSend,
      fileStepChange,
      fileList,
      fileUploaded,
      fileNotificationLater,
      confirmationChangeHandl,
      confirmationSend,
      workingChangeHandl
    },
    dispatch
  );
}

export default containerActions;



// WEBPACK FOOTER //
// ./src/pages/Upload/actions.js